import { cn } from "@/lib/utils";

interface MarqueeProps {
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  children?: React.ReactNode;
  vertical?: boolean;
  repeat?: number;
  [key: string]: unknown;
  duration: number;
}

export default function Marquee({
  className,
  reverse,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  duration = 20,
  ...props
}: MarqueeProps) {
  return (
    <div
      style={{ "--duration": `${duration}s` } as React.CSSProperties}
      {...props}
      className={cn(
        "testify-group testify-flex testify-overflow-hidden testify-p-2 [--gap:1rem] [gap:var(--gap)]",
        {
          "testify-flex-row": !vertical,
          "testify-flex-col": vertical,
        },
        className,
      )}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={cn(
              "testify-flex testify-shrink-0 testify-justify-around [gap:var(--gap)]",
              {
                "testify-animate-marquee testify-flex-row": !vertical,
                "testify-animate-marquee-vertical testify-flex-col": vertical,
                "testify-group-hover:[animation-play-state:paused]":
                  pauseOnHover,
                "[animation-direction:reverse]": reverse,
              },
            )}
          >
            {children}
          </div>
        ))}
    </div>
  );
}
